/**
 * 路由sid缓存工具
 */
import config from '@/config'

const getStorage = function () {
  if (typeof window === 'undefined') {
    return null
  }
  return window.sessionStorage
}

const getCacheToken = function () {
  const storage = getStorage()
  if (!storage) {
    return ''
  }
  return storage.getItem(config.tokenCacheKey) || ''
}

const setCacheToken = function (token) {
  const storage = getStorage()
  if (!storage) {
    return
  }
  if (token) {
    storage.setItem(config.tokenCacheKey, token)
  }
}

export default {
  getCacheToken: getCacheToken,
  setCacheToken: setCacheToken
}
